import { render, staticRenderFns } from "./ShipmentListPage.vue?vue&type=template&id=511f165a&scoped=true"
import script from "./ShipmentListPage.vue?vue&type=script&lang=js"
export * from "./ShipmentListPage.vue?vue&type=script&lang=js"
import style0 from "./ShipmentListPage.vue?vue&type=style&index=0&id=511f165a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511f165a",
  null
  
)

export default component.exports